import config from "../../../config";

export function remove(
  shlCycleId: number,
  ids: number[],
  setReload: (b: boolean) => void,
  fetchWithUser: (
    endpoint: RequestInfo,
    options?: RequestInit,
    scopes?: string[]
  ) => Promise<Response>
) {
  const url = `${config.apiUrl}/SHLCycle/RemoveEmployeesFromSHLCycle?shlCycleID=${shlCycleId}`;
  fetchWithUser(url, {
    method: "POST",
    body: JSON.stringify(ids),
    headers: {
      "Content-Type": "application/json",
    },
  }).then((_) => {
    setReload(true);
  });
}
